import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { BiPlus } from "react-icons/bi";
import Modal from "../../../common/modal";
import Loading from "../../../common/loading";
import useStore from "../../../../features/store";
import OwnerImg_1 from "../../../../assets/newresult/owner-1.png";
import OwnerImg_2 from "../../../../assets/newresult/owner-2.png";
import OwnerImg_3 from "../../../../assets/newresult/owner-3.png";
import { scrollToTop } from "../../../../utils/Functions";

const owners_options = [
  {
    id: 1,
    title: "برای خودم",
    subtitle: "اگه آزمایش برای خودته این گزینه رو بزن.",
    image: OwnerImg_1,
    is_active: true,
  },
  {
    id: 2,
    title: "برای آشنایان",
    subtitle: "اگه آزمایش برای یکی از آشناهاست این گزینه رو بزن.",
    image: OwnerImg_2,
    is_active: true,
  },
  {
    id: 3,
    title: "برای حیوان خانگی",
    subtitle: "اگه آزمایش برای سگ یا گربته این گزینه رو بزن.",
    image: OwnerImg_3,
    is_active: false,
  },
];

const TestOwner = ({
  testOwner,
  setTempProfile,
  setTestOwner,
  setStep,
  isLoadingTempUsers,
}: any) => {
  const { profile, isLoadingProfile, tempUsers, fetchTempUsers }: any =
    useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempUsersModal, setTempUsersModal] = useState(false);

  const handleOwnerSelect = (value: any) => {
    if (value === 1) {
      if (
        !profile.birth_day ||
        !profile.gender ||
        !profile.user.first_name ||
        !profile.user.last_name
      ) {
        setIsModalOpen(true);
      } else {
        setTestOwner(value);
      }
    } else {
      setTestOwner(value);
    }
    scrollToTop();
    setStep(2);
  };

  useEffect(() => {
    if (!tempUsers) fetchTempUsers();
  }, [tempUsers]);

  return (
    <div className="w-full flex items-start justify-start mb-10 mt-16">
      <Fade key={testOwner} triggerOnce className="w-full">
        <div>
          {isLoadingTempUsers || isLoadingProfile ? (
            <Loading type="SimpleTextLoading" />
          ) : (
            <div>
              <div className="mb-10">
                <h6 className="text-xl lg:text-3xl font-[900] font-rokh text-center">
                  آزمایش چه کسی رو تحلیل می‌کنی؟
                </h6>
                <p className="text-center">
                  شما می‌تونید آزمایش خودتون، آشنایانتون و حیوانات خانگیتون رو
                  تحلیل کنید.
                </p>
              </div>

              <div className="w-full flex flex-col lg:flex-row items-center mt-2 gap-5">
                {owners_options.map((owner: any) => (
                  <div
                    key={owner.id}
                    onClick={() => {
                      if (owner.id === 1) {
                        handleOwnerSelect(owner.id);
                      } else if (owner.id === 2) {
                        if (tempUsers.count > 0) {
                          setTempUsersModal(true);
                        } else {
                          setTempProfile("new-user");

                          handleOwnerSelect(owner.id);
                        }
                      }
                    }}
                    className={`relative flex-1 w-full border rounded-xl p-8 lg:h-52 border-2 duration-300 ${
                      !owner.is_active
                        ? "opacity-[0.5]"
                        : "opacity-1 hover:border-pr_purple_dark cursor-pointer"
                    } ${testOwner === owner.id ? "border-pr_purple_dark" : ""}`}
                  >
                    <h3 className="font-rokh font-[900] text-lg lg:text-xl mb-1">
                      {owner.title}
                    </h3>
                    <p className="text-sm font-rokh font-[700] pl-16 lg:pl-0">
                      {owner.subtitle}
                    </p>
                    <img
                      src={owner.image}
                      alt={owner.title}
                      className={`absolute left-3 ${
                        owner.id === 3
                          ? "h-[45px] lg:h-[60px] bottom-0"
                          : "h-[80px] lg:h-[100px] -bottom-[4px]"
                      } `}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Fade>

      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="flex flex-col items-center justify-center mt-14">
            <p className="font-[900] text-center">
              برای ثبت آزمایش لازم است که اطلاعات پروفایل تکمیل شود.
            </p>
            <Link
              to="/profile"
              className="btn btn-wide bg-pr_primary hover:bg-pr_primary duration-300 hover:shadow-xl my-5 text-white font-rokh font-[900] pt-2"
            >
              تکمیل پروفایل
            </Link>
          </div>
        </Modal>
      )}

      {tempUsersModal && (
        <Modal isOpen={tempUsersModal} onClose={() => setTempUsersModal(false)}>
          <div className="flex flex-col items-center justify-center mt-10">
            <p className="font-[900] text-center">
              آزمایش چه کسی رو تحلیل می‌کنی؟
            </p>
            <div className="w-full mt-5">
              {tempUsers.count > 0 &&
                tempUsers.results.map((user: any) => (
                  <div
                    key={user.id}
                    className="bg-gray-100 mb-2 px-4 py-1 rounded"
                    onClick={() => {
                      setTempProfile(user);
                      handleOwnerSelect(2);
                    }}
                  >
                    <p className="text-sm font-rokh font-[700] pt-1">
                      {user.first_name} {user.last_name} ({user.name})
                    </p>
                  </div>
                ))}
              <div
                className="flex items-center bg-gray-100 mb-2 px-4 py-1 rounded"
                onClick={() => {
                  setTempProfile("new-user");
                  handleOwnerSelect(2);
                }}
              >
                <BiPlus className="ml-2" />
                <p className="text-sm font-rokh font-[700] pt-1">
                  افزودن کاربر جدید
                </p>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default TestOwner;
